import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

const dtGpsSourcesConfig = dtConfig[ModulesMap.GPS_SOURCES]

function getGpsSources(companyId) {
	return dataTransferWrap(
		ModulesMap.GPS_SOURCES,
		dtGpsSourcesConfig[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES],
		{
			urlParams: {
				companyId,
			},
		},
	)
}

function createGpsSource(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtGpsSourcesConfig[ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE],
		{
			urlParams: {
				companyId,
			},
			...payload,
		}
	)
}

function getGpsSource(companyId, gpsSourceId) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtGpsSourcesConfig[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE],
		{
			urlParams: {
				companyId,
				gpsSourceId,
			},
		}
	)
}

function patchGpsSource(companyId, gpsSourceId, payload) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtGpsSourcesConfig[ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE],
		{
			urlParams: {
				companyId,
				gpsSourceId,
			},
			...payload,
		}
	)
}

export default {
	getGpsSources,
	createGpsSource,
	getGpsSource,
	patchGpsSource,
}
